module.exports = __webpack_public_path__ + "static/img/1-2.cb2198a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/1-2.png
// module id = n0Pp
// module chunks = 0